import { ChartResultStatus, type ChartResult } from '../catalog/types';

export const IDLE_CHART_RESULT: ChartResult = {
  status: ChartResultStatus.idle,
  rawData: null,
  filters: undefined,
  dataGeneratedAt: null,
  error: null,
  reload: (): void => undefined,
};

export function normalizeChartFetchResult(
  result: ChartResult & { toChartResult?: () => ChartResult }
): ChartResult {
  return result.toChartResult?.() ?? result;
}
